import { Body1, Caption } from '@xo-union/tk-ui-typography';
import React from 'react';

import shared from './headline.scss';
import { Item, ItemProps } from './Item';
import styles from './photoGalleryItem.scss';

interface PhotoItem {
  id: number;
  mediaUrl?: string | null;
}

interface Props extends Omit<ItemProps, 'children'> {
  photoItems?: PhotoItem[] | null;
  captionText?: string;
}

const imagesCount = 5;

export const PhotoGalleryItem: React.FC<Props> = ({ captionText, photoItems, onClick, ...rest }) => (
  <Item onClick={onClick} {...rest}>
    <div className={shared.container}>
      <Caption className={styles.title}>{captionText || 'Photo Gallery'}</Caption>
      <div className={styles.container}>
        {photoItems &&
          photoItems.length &&
          photoItems.slice(0, imagesCount).map((photo, i) => {
            if (!photo.mediaUrl) {
              return null;
            }
            return (
              <img
                key={photo.id}
                className={`${styles.background} ${styles.img}`}
                src={photo.mediaUrl}
                alt={`Gallery Item ${i + 1}`}
              />
            );
          })}
        {photoItems && photoItems.length > imagesCount && (
          <Body1 data-testid="more-photos" className={`${styles.background} ${styles.center}`}>
            <div className={`${styles.photoCount}`}>+ {photoItems.length - imagesCount}</div>
            <div>Photos</div>
          </Body1>
        )}
      </div>
    </div>
  </Item>
);
